import HorizontalSplitIcon from "@mui/icons-material/HorizontalSplit";
import VerticalSplitIcon from "@mui/icons-material/VerticalSplit";
import {
  ToggleButton,
  ToggleButtonGroup,
  Slider,
  FormHelperText,
  FormControl,
} from "@mui/material";

export default function DisplaySelector({
  selectedOrientation,
  selectedSliderValue,
  handleOrientationChange,
  handleSliderValueChange,
}) {
  const handleToggle = (event, newValue) => {
    if (newValue !== null) {
      handleOrientationChange(newValue);
    }
  };

  const handleSplit = (event, newValue) => {
    if (newValue !== null) {
      handleSliderValueChange(newValue);
    }
  };

  return (
    <>
      <FormControl style={{ marginLeft: 10 }}>
        <ToggleButtonGroup
          orientation="horizontal"
          value={selectedOrientation}
          exclusive
          color="primary"
          onChange={handleToggle}
          size="large"
        >
          <ToggleButton value="vertical" aria-label="list">
            <HorizontalSplitIcon />
          </ToggleButton>
          <ToggleButton value="sidebyside" aria-label="module">
            <VerticalSplitIcon />
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>
      {selectedOrientation === "sidebyside" && (
        <FormControl style={{ marginLeft: 10 }}>
          <Slider
            value={selectedSliderValue}
            onChange={handleSplit}
            aria-label="Left Column Width"
            valueLabelDisplay="auto"
            min={30}
            max={70}
            step={10}
            style={{ width: 200 }}
          />
          <FormHelperText sx={{ fontSize: "0.8rem" }}>
            Display Split ({selectedSliderValue}%/{100 - selectedSliderValue}%)
          </FormHelperText>
        </FormControl>
      )}
    </>
  );
}
